import { Button } from '../../../cdl/Button/Button';
import { useDrawer } from '../../../cdl/Drawer/useDrawer.hook';
import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { IconPlus } from '../../../common/icons/cdl/Plus';
import { IconUsers } from '../../../common/icons/cdl/Users';
import { Box } from '../../../common/ui/Box';

import { InviteUser } from './InviteUserButton';

export const NoMembersState = () => {
    const { push, pop } = useDrawer();
    return (
        <Box marginTop="124px" display="flex" justifyContent="center">
            <StatePlaceholder
                Icon={IconUsers}
                action={
                    <Button
                        LeadingIcon={IconPlus}
                        emphasis="high"
                        onClick={() => {
                            const drawerId = push({
                                header: { title: translate('user.inviteTitle') },
                                content: <InviteUser onSuccess={() => pop(drawerId)} />,
                            });
                        }}
                    >
                        {translate('users.invite')}
                    </Button>
                }
                title={translate('members.addMembers.title')}
                description={translate('members.addMembers.description')}
            />
        </Box>
    );
};
